import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import { SimpleImg } from 'react-simple-img'

import blueQuotes from '../../../images/about-us/Quotes_v2_Blue.svg'
import lightQuotes from '../../../images/quotes.svg'

const Quote = ({ image, name, title, darkTheme, quote }) => {
  const themeClass = classNames('section is-large', {
    'bg-gradient-reverse': !darkTheme,
    'bg-dark bg-static-stars': darkTheme,
  })

  return (
    <section className={themeClass}>
      <div className="container content u-paddingsides-mobile">
        <div className="columns is-centered is-multiline">
          <div className="column is-1-desktop is-1-tablet is-12-mobile">
            <SimpleImg
              className="icon righted"
              src={darkTheme ? blueQuotes : lightQuotes}
              alt="quotation maarks icon"
              height={80}
              style={{ display: 'block' }}
              placeholder="rgba(255,0,0,0.0)"
            />
          </div>
          <div className="column is-8-desktop is-8-tablet is-12-mobile">
            <h2 className="title quote">{quote}</h2>
            <svg className="stroke-10">
              <line x1="0" y1="0" x2="100%" y2="0" />
            </svg>
            <div className="homepage-quote">
              <SimpleImg
                src={image}
                alt={name}
                height={80}
                placeholder="rgba(255,0,0,0.0)"
              />
              <div>
                <p className="quote-text">{name}</p>
                <p className="quote-text">{title}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

Quote.defaultProps = {
  darkTheme: false,
}

Quote.propTypes = {
  darkTheme: PropTypes.bool,
  image: PropTypes.string,
  quote: PropTypes.string,
  name: PropTypes.string,
  title: PropTypes.string,
}

export default Quote
